import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../../i18n';
import './LanguageModal.scss';

export default function LanguageModal({ isOpen, onClose }) {
  const { t, i18n } = useTranslation();

  if (!isOpen) return null;

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    onClose();
  };

  return (
    <div className="lang-modal-overlay" onClick={onClose}>
      <div className="lang-modal" onClick={(e) => e.stopPropagation()}>
        <div className="lang-modal__header">
          <h3 className="lang-modal__title">{t('layout:sidebar.actions.language')}</h3>
          <button className="lang-modal__close" onClick={onClose}>&times;</button>
        </div>
        <div className="lang-modal__list">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              className={`lang-modal__item ${i18n.language === lang.code ? 'active' : ''}`}
              onClick={() => handleSelect(lang.code)}
            >
              <span className="lang-modal__flag">{lang.flag}</span>
              <span className="lang-modal__label">{lang.label}</span>
              {i18n.language === lang.code && (
                <span className="lang-modal__check">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
